module.exports = __webpack_public_path__ + "img/success.7320050d.svg";